<template>
  <IdeaActivityNotification
    :notification="notification"
    title="Idea have been added"
    :resourceKey="resourceKey"
  >
    <template #pic>
      <div class="label-pic is-yellow">
        <icon
          data="@icon/idea.svg"
          class="label-pic__icon idea-activity-created__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
  </IdeaActivityNotification>
</template>

<script setup lang="ts">
import { computed } from "vue"

import IdeaActivityNotification from "@/components/Notification/components/IdeaActivityNotification.vue"

import { NotificationIdeaActivity } from "@/models/Notification"

const props = defineProps<{
  notification: NotificationIdeaActivity
}>()

const resourceKey = computed(() => {
  const sequenceNumber = props.notification.displayEvent?.ideaSequenceNumber
  return sequenceNumber === undefined ? "" : `I-${sequenceNumber}`
})
</script>

<style lang="scss" scoped>
.idea-activity-created__icon {
  :deep(path) {
    fill: var(--markingYellow-03);
  }
}
</style>
